<template>
  <div>
    <vs-popup
      ref="pmPopup"
      :active.sync="showPopupByColumnKey"
      class="pmdw-popup"
      id="vs_edit_cell_popup"
      :title="popupTitle"
    >
      <div v-if="popupColumnKey === 'order_type'">
        <dialog-order-type
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-order-type>
      </div>
      <div v-if="popupColumnKey === 'order_at'">
        <dialog-order-at
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-order-at>
      </div>
      <div v-if="popupColumnKey === 'progress'">
        <dialog-progress
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-progress>
      </div>
      <div v-if="popupColumnKey === 'berth'">
        <dialog-berth
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-berth>
      </div>
      <div v-if="popupColumnKey === 'vehicles'">
        <dialog-vehicles
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-vehicles>
      </div>
      <div v-if="popupColumnKey === 'tug_boats'">
        <dialog-tug-boats
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-tug-boats>
      </div>
      <div v-if="popupColumnKey === 'head_count'">
        <dialog-head-count
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-head-count>
      </div>
      <div v-if="popupColumnKey === 'rope_boats'">
        <dialog-rope-boats
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-rope-boats>
      </div>
      <div v-if="popupColumnKey === 'boardside_type'">
        <dialog-boardside-type
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-boardside-type>
      </div>
      <div v-if="popupColumnKey === 'flag'">
        <dialog-flag
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-flag>
      </div>
      <div v-if="popupColumnKey === 'bit'">
        <dialog-bit
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-bit>
      </div>
      <div v-if="popupColumnKey === 'pilot'">
        <dialog-pilot
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-pilot>
      </div>
      <div v-if="popupColumnKey === 'team_leader'">
        <dialog-team-leader
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-team-leader>
      </div>
      <div v-if="popupColumnKey === 'caution_note'">
        <dialog-caution-note
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-caution-note>
      </div>
      <div v-if="popupColumnKey === 'weather'">
        <dialog-weather
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-weather>
      </div>
      <div v-if="popupColumnKey === 'vessel'">
        <div v-if="popupValueMap.order_type != '4'">
          <dialog-port-vessel
            :showPopup="showPopup"
            :columnKey="popupColumnKey"
            :valueMap="popupValueMap"
            :taskId="popupTaskId"
            :isInsertOneMode="isInsertOneMode"
            :isImportEditMode="isImportEditMode"
            @updateValue="updateValue"
          >
          </dialog-port-vessel>
        </div>
        <div v-else>
          <dialog-other-task
            :showPopup="showPopup"
            :columnKey="popupColumnKey"
            :valueMap="popupValueMap"
            :taskId="popupTaskId"
            :isInsertOneMode="isInsertOneMode"
            :isImportEditMode="isImportEditMode"
            @updateValue="updateValue"
          >
          </dialog-other-task>
        </div>
      </div>
      <div v-if="popupColumnKey === 'previous'">
        <div v-if="popupValueMap.order_type != '3'">
          <dialog-previous
            :showPopup="showPopup"
            :columnKey="popupColumnKey"
            :valueMap="popupValueMap"
            :taskId="popupTaskId"
            :isInsertOneMode="isInsertOneMode"
            :isImportEditMode="isImportEditMode"
            @updateValue="updateValue"
          >
          </dialog-previous>
        </div>
        <div v-else>
          <dialog-berth
            columnKey="previous#berth_id"
            :valueMap="popupValueMap.berth"
            :taskId="popupTaskId"
            :isInsertOneMode="isInsertOneMode"
            :isImportEditMode="isImportEditMode"
            @updateValue="updateValue"
          >
          </dialog-berth>
        </div>
      </div>
      <div v-if="popupColumnKey === 'progress_at'">
        <dialog-progress-at
          :showPopup="showPopup"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-progress-at>
      </div>
      <div v-if="popupColumnKey === 'shipping_agency'">
        <dialog-shipping-agency
          :showPopup="showPopup"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-shipping-agency>
      </div>
      <div v-if="popupColumnKey === 'required_note'">
        <dialog-required-note
          :showPopup="showPopup"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :isInsertOneMode="isInsertOneMode"
          :isImportEditMode="isImportEditMode"
          @updateValue="updateValue"
        >
        </dialog-required-note>
      </div>

    </vs-popup>

  </div>
</template>

<script>
import DialogOrderType from "./DialogOrderType";
import DialogOrderAt from "./DialogOrderAt";
import DialogProgress from "./DialogProgress";
import DialogBerth from "./DialogBerth";
import DialogVehicles from "./DialogVehicles";
import DialogTugBoats from "./DialogTugBoats";
import DialogHeadCount from "./DialogHeadCount";
import DialogRopeBoats from "./DialogRopeBoats";
import DialogBoardsideType from "./DialogBoardsideType";
import DialogFlag from "./DialogFlag";
import DialogBit from "./DialogBit";
import DialogPilot from "./DialogPilot";
import DialogTeamLeader from "./DialogTeamLeader";
import DialogCautionNote from "./DialogCautionNote";
import DialogWeather from "./DialogWeather";
import DialogPortVessel from "./DialogPortVessel";
import DialogOtherTask from "./DialogOtherTask";
import DialogPrevious from "./DialogPrevious";
import DialogShippingAgency from "./DialogShippingAgency";
import DialogProgressAt from "./DialogProgressAt";
import DialogRequiredNote from "./DialogRequiredNote";


import { createNamespacedHelpers } from "vuex";
import Vue from "vue";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");

export default {
  props: {
    showPopup:        { type: Boolean, required: true },
    clickX:           { type: Number,  required: true },
    clickY:           { type: Number,  required: true },
    popupTitle:       { type: String,  required: true },
    popupTaskId:      { type: String,  required: true },
    popupColumnKey:   { type: String,  required: true },
    popupValueMap:    { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  components: {
    DialogOrderType,
    DialogOrderAt,
    DialogProgress,
    DialogBerth,
    DialogVehicles,
    DialogTugBoats,
    DialogHeadCount,
    DialogRopeBoats,
    DialogBoardsideType,
    DialogFlag,
    DialogBit,
    DialogPilot,
    DialogTeamLeader,
    DialogCautionNote,
    DialogWeather,
    DialogPortVessel,
    DialogOtherTask,
    DialogPrevious,
    DialogProgressAt,
    DialogShippingAgency,
    DialogRequiredNote,
  },
  data() {
    return {
      showPopupByColumnKey: false,
    };
  },
  watch: {
    showPopup() {
      if (this.showPopup === true) {
        this.showDialogByColumnKey();
      }
    },
    showPopupByColumnKey(){
      if (this.showPopupByColumnKey === false) {
        this.$emit("update:showPopup", false);
      }
    }
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      selectedDateDisplay1: state => state.selectedDateDisplay1,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),    
  },
  methods: {
    ...mapActions(["updateDestinationWorkTask", "updateFirestoreDocument"]),
    showDialogByColumnKey() {
      const vsEditCellPopup = document.getElementById('vs_edit_cell_popup');
      const vsPopup = vsEditCellPopup.querySelector("div.vs-popup");

      const popupDefaultWidth = Math.floor(document.documentElement.clientWidth * 5 / 12);
      vsPopup.style.width = popupDefaultWidth + 30 + 'px';

      this.showPopupByColumnKey = true;
    },
    async updateValue(...args) {
      const [taskId, updateKeyValueMap, mode, columnKey] = args
      Vue.$log.debug(updateKeyValueMap)
      // this.$vs.loading();
      let updateData = {
        enterprisePort: this.selectedPort,
        taskId: taskId,
        data: updateKeyValueMap,
        updateMode: mode ? mode.includes("update") : false,
        updateTimeStamp: mode ? mode.includes("updateTimeStamp") : false,
        toNextColumn: mode ? mode.includes("toNextColumn") : false,
        columnKey: columnKey,
        isImportedData: this.isImportEditMode,
        isInsertOneMode: this.isInsertOneMode,
        targetDate: this.isImportEditMode ? this.$route.params.date : this.isInsertOneMode ? this.selectedDateDisplay1 : null,
      };

      // caution_noteのときは更新せず
      if (updateData.data) updateData.data.input_type = 1

      Vue.$log.debug("updateData", updateData);
      try {
        if (columnKey != "caution_note") {
          if (!this.isInsertOneMode && !this.isImportEditMode) {
            await this.updateFirestoreDocument(updateData)
          }
          this.updateDestinationWorkTask(updateData);
        }
        this.$emit('updateGridCell', updateData);
      } catch (e) {
        this.$vs.notify({
          title: "サーバ側の登録処理に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
          position: "bottom-center",
        });
      }

      this.showPopupByColumnKey = false;
    },
   },
  mounted() {
  },
};
</script>

<style lang="scss">
#dialog-user-search-input-form {
  ul li {
    display: inline;
  }
  .input-user-name {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
}
.pmdw-popup {
  .vs-popup--content {
    overflow: visible;
  }
}
</style>

